'use strict';

module.exports = {
    unauthorized: 'Unauthorized',
    internalServerError: 'internal.server.error',
    transferNotFound: 'transfer.notFound',
    requestInvalid: 'request.invalid',
    transferStartFailed: 'transfer.startFailed',
    transferFailed: 'transfer.failed',
    transferIllegalStateTransition: 'transfer.illegalStateTransition',
    useFlightGatewayNotAllowed: 'transfer.options.useFlightGateway.notAllowed',
    testOptionNotAllowed: 'transfer.destination.options.test.notAllowed',
    S3ToS3NotAllowed: 'transfer.S3ToS3.notAllowed',
    jobActionExecutionTimeout: 'jobActionExecution.timeout'
};